import React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContentText,
  Stack,
} from "@mui/material";
import {
  dialogTitleStyle,
  subHeadingStyle,
} from "../../styles/MUI-style-constants.js";
import "../../styles/generate-captions.scss";
import "../../styles/global.scss";

const WelcomeMessage = (props) => {
  const handleClose = () => {
    props.setShowWelcomeMessage(false);
  };

  const handleContinue = () => {
    handleClose();
    props.handleSubmit();
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle style={dialogTitleStyle}>
          {"Welcome to CaptionAI!"}
        </DialogTitle>
        <DialogContentText style={subHeadingStyle}>
          {
            "You can try this app twice before signing up and getting expanded functionality."
          }
        </DialogContentText>
        <Stack direction="row" justifyContent="space-evenly" margin={2}>
          <Button variant="contained" color="cc" onClick={handleContinue}>
            Continue
          </Button>
        </Stack>
      </Dialog>
    </div>
  );
};

export default WelcomeMessage;
